import { lazy, Suspense } from 'react';
import { useIdioma } from './i18n/useIdioma';
import { useOuvinteAtalhos } from './input/useAtalhos';
import { CharacterScreen } from './screens/CharacterScreen';
import { CreateScreen } from './screens/CreateScreen';
import { AcessoPublico } from './screens/AcessoPublico';
import { PortaDeEntrada } from './screens/PortaDeEntrada';
import { ShardScreen } from './screens/ShardScreen';
import { KitScreen } from './screens/KitScreen';
import { WorldScreen } from './screens/WorldScreen';
import { useSession } from './state/SessionContext';
import { ehWiki } from './screens/wiki/rota';
import { prepararOrigem } from './origem/visita';

// A visita do site e o link de convite /c/{codigo} (techspec-indicacoes §03.1): antes da primeira rota.
prepararOrigem();

/** A Wiki só baixa quando alguém abre /wiki (techspec-wiki §05). */
const Wiki = lazy(() => import('./screens/wiki/Wiki'));
/** O site do parceiro (techspec-parceiros §03): só baixa quando alguém abre /parceiros. */
const Parceiros = lazy(() => import('./screens/parceiros/Parceiros'));

/**
 * Rotas antigas do formulário (`/alpha`, `/pre-registro`) viram a landing aberta no
 * formulário; os links dos e-mails (`/pre-registro/*` e os antigos `/alpha/*`) e o convite
 * vão para as páginas públicas (techspec-landing-fase §05.1).
 */
function rotaAtual(): string {
  const caminho = window.location.pathname.replace(/\/+$/, '') || '/';
  if (caminho === '/alpha' || caminho === '/pre-registro') {
    // Mantém a query (?ref= do link de divulgação).
    window.history.replaceState(null, '', `/${window.location.search}#pre-registro`);
    return '/';
  }
  return caminho;
}

function ehPaginaPublica(caminho: string): boolean {
  return caminho === '/convite'
    || caminho.startsWith('/convite/')
    || caminho.startsWith('/pre-registro/')
    || caminho.startsWith('/alpha/');
}

export function App() {
  useIdioma();   // assina a troca de idioma: a árvore inteira redesenha
  useOuvinteAtalhos();
  if (import.meta.env.DEV && window.location.pathname === '/kit') return <KitScreen />;
  // Wiki: pública e sempre aberta, em qualquer fase (não passa pela porta de entrada).
  if (ehWiki(rotaAtual())) return <Suspense fallback={null}><Wiki /></Suspense>;
  // Parceiros: público (com a conta do jogo), em qualquer fase. Fica fora do switch de etapas: entrar não leva ao jogo.
  if (rotaAtual() === '/parceiros') return <Suspense fallback={null}><Parceiros /></Suspense>;
  if (ehPaginaPublica(rotaAtual())) return <AcessoPublico />;
  const { stage } = useSession();

  switch (stage) {
    case 'login':     return <PortaDeEntrada />;
    case 'shard':     return <ShardScreen />;
    case 'character': return <CharacterScreen />;
    case 'create':    return <CreateScreen />;
    case 'world':     return <WorldScreen />;
  }
}
